<template>
  <div :style="{ padding: '12px', minHeight: '360px' }">
    <a-bread-crumb
      :crumbs="[
        { path: 'keys', name: 'Keys' },
        { name: `${key.key_algorithm} - ${key.uuid}` }
      ]"
    />
    <a-tabs defaultActiveKey="1" :size="size">
      <a-tab-pane tab="General" key="1">
        <a-skeleton
          active
          :loading="loading"
          :title="false"
          :paragraph="{ rows: 8, width: 800 }"
        >
          <a-form :layout="formLayout" :form="form">
            <a-text-clipboard-field
              varName="uuid"
              varLabel="Key ID"
              :varRequired="true"
              :varInitial="key.uuid"
              :formLayout="formLayout"
              :size="size"
              :disabled="true"
              :value="key.uuid"
            />
            <a-text-field
              varName="key_algorithm"
              varLabel="Key Algorithm"
              :varRequired="true"
              :varInitial="key.key_algorithm"
              :formLayout="formLayout"
              :size="size"
              :disabled="true"
              :value="key.key_algorithm"
            />
            <a-switch-field
              varName="is_default"
              varLabel="Default Key"
              :varRequired="false"
              :formLayout="formLayout"
              :size="size"
              :varInitial="key.is_default"
              description="Default key is used for signing and encrypting the payloads. There can be only one default key per type."
            />
            <a-switch-field
              varName="is_active"
              varLabel="Active Key"
              :varRequired="false"
              :formLayout="formLayout"
              :size="size"
              :varInitial="key.is_active"
              description="Only update this if you need forced rotation of the key, otherwise it will be deactivated automatically."
            />
            <a-submit-button
              @submit="handleSubmit"
              :formLayout="formLayout"
              btn_text="Update details"
              styled="margin-top:0.5em; padding-left:4em;"
            />
          </a-form>
        </a-skeleton>
      </a-tab-pane>
      <a-tab-pane tab="Download Keys" key="2">
        <a-collapse accordion defaultActiveKey="1">
          <a-collapse-panel header="JSON Web Key" key="1">
            <div class="key-code">
              <a-icon
                type="copy"
                style="font-size:25px;"
                v-clipboard:copy="JSON.stringify(key.private_key)"
                @click="success"
              ></a-icon>
              <pre>{{ key.private_key }}</pre>
            </div>
          </a-collapse-panel>
          <a-collapse-panel header="Private PEM Key" key="2" v-if="key.key_algorithm !== 'oct'">
            <div class="key-code">
              <a-icon
                type="copy"
                style="font-size:25px;"
                v-clipboard:copy="toPem(key.private_key, true)"
                @click="success"
              ></a-icon>
              <pre>{{ key.private_key | filterPem(true) }}</pre>
            </div>
          </a-collapse-panel>
          <a-collapse-panel header="Public PEM Key" key="3" v-if="key.key_algorithm !== 'oct'">
            <div class="key-code">
              <a-icon
                type="copy"
                style="font-size:25px;"
                v-clipboard:copy="toPem(key.private_key)"
                @click="success"
              ></a-icon>
              <pre>{{ key.private_key | filterPem }}</pre>
            </div>
          </a-collapse-panel>
        </a-collapse>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";
import jwkToPem from "jwk-to-pem";

export default {
  data() {
    return {
      loading: true,
      size: "large",
      formLayout: "horizontal",
      form: this.$form.createForm(this)
    };
  },
  mixins: [formLayoutMixin],

  components: {},

  filters: {
    filterPem(jwk, pri = false) {
      return pri ? jwkToPem(jwk, { private: pri }) : jwkToPem(jwk);
    }
  },
  computed: {
    key() {
      return this.$store.state.tenant.keys_item
        ? this.$store.state.tenant.keys_item
        : {};
    }
  },

  methods: {
    toPem(jwk, pri) {
      return pri ? jwkToPem(jwk, { private: pri }) : jwkToPem(jwk);
    },
    async handlePemDownload() {},
    handleSubmit() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            await this.$store.dispatch("tenant/patchItem", {
              endpoint: "keys",
              uuid: this.$route.params.uuid,
              data: values
            });
            await this.$notification.open({
                message: 'Updated!',
                description: 'Key settings updated',
                icon: <a-icon type="check-circle" theme="filled" style="color: green" />
            });
          } catch (error) {
            console.error(error);
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    },
    success() {
      this.$message.success("Key copied.", 5);
    }
  },

  beforeCreate: async function() {
    this.form = this.$form.createForm(this);
    try {
      await this.$store.dispatch("tenant/getItem", {
        endpoint: "keys",
        uuid: this.$route.params.uuid
      });
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }
};
</script>

<style lang="css">
.key-code {
  margin-top: 10px;
  width: 100%;
}
</style>
